import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";

function ResultsPage() {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  const [sideOpen, setSideOpen] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("access");
    if (!token) { navigate("/login"); return; }
    fetchResults();
  }, []);

  const fetchResults = async () => {
    try {
      const res = await api.get("results/");
      setResults(res.data ?? []);
    } catch {
      setResults([
        { id:1, name:"Complete Blood Count (CBC)", date:"2026-02-28", status:"completed", doctor:"Dr. Sarah Johnson", category:"Hematology", flagged:false },
        { id:2, name:"Lipid Panel", date:"2026-02-25", status:"completed", doctor:"Dr. Michael Chen", category:"Chemistry", flagged:true },
        { id:3, name:"Chest X-Ray", date:"2026-02-20", status:"completed", doctor:"Dr. Emily Brown", category:"Radiology", flagged:false },
        { id:4, name:"Urinalysis", date:"2026-03-05", status:"pending", doctor:"Dr. Sarah Johnson", category:"Urinalysis", flagged:false },
        { id:5, name:"HbA1c", date:"2026-03-01", status:"completed", doctor:"Dr. Michael Chen", category:"Chemistry", flagged:false },
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    navigate("/login");
  };

  const filtered = results.filter(r => filter === "all" ? true : r.status === filter);
  const flagged = results.filter(r => r.flagged).length;
  const completed = results.filter(r => r.status === "completed").length;
  const pending = results.filter(r => r.status === "pending").length;
  const W = sideOpen ? "210px" : "50px";

  const fmtDate = (d) => d ? new Date(d).toLocaleDateString("en-US", { month:"short", day:"numeric", year:"numeric" }) : "—";

  if (loading) return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"center", minHeight:"100vh", fontFamily:"Inter,sans-serif", color:"#6b7280", fontSize:13 }}>
      <div style={{ textAlign:"center" }}>
        <div style={{ width:32, height:32, border:"2px solid #e5e7eb", borderTopColor:"#00897B", borderRadius:"50%", animation:"spin .7s linear infinite", margin:"0 auto 12px" }}></div>
        Loading results…
        <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      </div>
    </div>
  );

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'Inter', sans-serif; background: #f1f5f9; color: #111; font-size: 13px; -webkit-font-smoothing: antialiased; }
        button { font-family: inherit; cursor: pointer; }
        .app { display: flex; min-height: 100vh; }

        .sb { width: ${W}; background: #00897B; display: flex; flex-direction: column; position: fixed; top:0; left:0; bottom:0; z-index:200; transition: width .2s; overflow: hidden; }
        .sb-logo { height:56px; display:flex; align-items:center; padding:0 13px; gap:9px; border-bottom:1px solid rgba(255,255,255,0.1); flex-shrink:0; }
        .sb-logo-box { width:28px; height:28px; border-radius:7px; background:#fff; display:flex; align-items:center; justify-content:center; flex-shrink:0; }
        .sb-logo-box svg { width:15px; height:15px; stroke:#00897B; fill:none; stroke-width:2.2; stroke-linecap:round; stroke-linejoin:round; }
        .sb-logo-name { font-size:13px; font-weight:700; color:#fff; white-space:nowrap; opacity:${sideOpen?1:0}; transition:opacity .15s; }
        .sb-logo-sub { font-size:9.5px; color:rgba(255,255,255,0.45); white-space:nowrap; opacity:${sideOpen?1:0}; transition:opacity .15s; }
        .sb-nav { flex:1; padding:10px 7px; overflow-y:auto; scrollbar-width:none; }
        .sb-grp { font-size:9.5px; font-weight:700; letter-spacing:.08em; text-transform:uppercase; color:rgba(255,255,255,0.3); padding:8px 8px 3px; white-space:nowrap; opacity:${sideOpen?1:0}; transition:opacity .15s; }
        .nb { width:100%; display:flex; align-items:center; gap:8px; padding:8px 9px; border-radius:7px; border:none; background:none; color:rgba(255,255,255,0.5); font-size:12.5px; font-weight:500; text-align:left; white-space:nowrap; margin-bottom:1px; transition:background .1s, color .1s; }
        .nb:hover { background:rgba(255,255,255,0.1); color:rgba(255,255,255,0.9); }
        .nb.on { background:rgba(255,255,255,0.15); color:#fff; font-weight:600; }
        .nav-ic { flex-shrink:0; width:15px; height:15px; display:flex; align-items:center; justify-content:center; }
        .nav-lbl { opacity:${sideOpen?1:0}; transition:opacity .15s; white-space:nowrap; }
        .sb-foot { border-top:1px solid rgba(255,255,255,0.1); padding:8px 7px; flex-shrink:0; }
        .sb-user { display:flex; align-items:center; gap:8px; padding:7px 9px; }
        .sb-av { width:28px; height:28px; border-radius:50%; background:rgba(255,255,255,0.18); display:flex; align-items:center; justify-content:center; font-size:10px; font-weight:700; color:#fff; flex-shrink:0; }
        .sb-uinfo { opacity:${sideOpen?1:0}; transition:opacity .15s; overflow:hidden; }
        .sb-uname { font-size:12px; font-weight:600; color:#fff; white-space:nowrap; }
        .sb-urole { font-size:10px; color:rgba(255,255,255,0.35); white-space:nowrap; }
        .sb-out { width:100%; display:flex; align-items:center; gap:8px; padding:7px 9px; border-radius:7px; border:none; background:none; color:rgba(255,255,255,0.3); font-size:12px; margin-top:2px; transition:background .1s, color .1s; }
        .sb-out:hover { background:rgba(239,68,68,0.15); color:#fca5a5; }
        .sb-out-lbl { opacity:${sideOpen?1:0}; transition:opacity .15s; }

        .main { margin-left:${W}; flex:1; display:flex; flex-direction:column; transition:margin-left .2s; min-width:0; }
        .topbar { height:56px; background:#fff; border-bottom:1px solid #e5e7eb; display:flex; align-items:center; justify-content:space-between; padding:0 18px; position:sticky; top:0; z-index:100; flex-shrink:0; }
        .tb-l { display:flex; align-items:center; gap:10px; }
        .tb-toggle { width:30px; height:30px; border-radius:6px; border:1px solid #e5e7eb; background:none; display:flex; align-items:center; justify-content:center; color:#6b7280; transition:background .1s; }
        .tb-toggle:hover { background:#f3f4f6; }
        .tb-title { font-size:13.5px; font-weight:700; color:#0f172a; }
        .tb-sub { font-size:11px; color:#9ca3af; }
        .tb-r { display:flex; align-items:center; gap:7px; }
        .tb-badge { display:flex; align-items:center; gap:5px; padding:4px 10px; border-radius:20px; background:#E0F2F1; font-size:10.5px; font-weight:600; color:#00897B; }
        .tb-av { width:30px; height:30px; border-radius:50%; background:#00897B; display:flex; align-items:center; justify-content:center; font-size:10px; font-weight:700; color:#fff; cursor:pointer; }

        .content { padding:16px; flex:1; }
        .page-head { margin-bottom:16px; }
        .page-title { font-size:20px; font-weight:700; color:#0f172a; margin-bottom:3px; }
        .page-sub { font-size:12px; color:#6b7280; }

        .stats { display:grid; grid-template-columns:repeat(4,1fr); gap:10px; margin-bottom:16px; }
        .stat { background:#fff; border:1px solid #e5e7eb; border-radius:10px; padding:13px 15px; }
        .stat-lbl { font-size:11px; color:#6b7280; font-weight:500; margin-bottom:6px; }
        .stat-n { font-size:26px; font-weight:700; color:#0f172a; line-height:1; }

        .filter-row { display:flex; align-items:center; gap:6px; margin-bottom:14px; flex-wrap:wrap; }
        .f-btn { padding:6px 14px; border-radius:7px; border:1px solid #e5e7eb; background:#fff; font-size:12px; font-weight:500; color:#6b7280; transition:all .1s; }
        .f-btn:hover { border-color:#00897B; color:#00897B; }
        .f-btn.on { background:#00897B; border-color:#00897B; color:#fff; font-weight:600; }

        .results-list { display:flex; flex-direction:column; gap:8px; }
        .res-card { background:#fff; border:1px solid #e5e7eb; border-radius:10px; padding:14px 16px; display:flex; align-items:center; gap:14px; transition:border-color .15s, transform .1s; }
        .res-card:hover { border-color:#00897B; transform:translateX(2px); }
        .res-card.flagged { border-left:3px solid #ca8a04; }
        .res-dot { width:10px; height:10px; border-radius:50%; flex-shrink:0; }
        .dot-green { background:#16a34a; }
        .dot-yellow { background:#ca8a04; }
        .dot-gray { background:#9ca3af; }
        .res-icon { width:38px; height:38px; border-radius:9px; background:#E0F2F1; display:flex; align-items:center; justify-content:center; flex-shrink:0; }
        .res-icon svg { width:18px; height:18px; stroke:#00897B; fill:none; stroke-width:1.8; stroke-linecap:round; stroke-linejoin:round; }
        .res-name { font-size:13px; font-weight:600; color:#0f172a; margin-bottom:2px; }
        .res-meta { font-size:11px; color:#9ca3af; }
        .res-cat { font-size:10px; font-weight:600; padding:2px 8px; border-radius:20px; background:#f1f5f9; color:#475569; margin-left:6px; }
        .flag-tag { font-size:10px; font-weight:600; padding:2px 8px; border-radius:20px; background:#fefce8; color:#ca8a04; }
        .status-pill { font-size:10.5px; font-weight:600; padding:3px 10px; border-radius:20px; white-space:nowrap; }
        .pill-green { background:#f0fdf4; color:#16a34a; }
        .pill-yellow { background:#fefce8; color:#ca8a04; }
        .btn-view { padding:5px 12px; border-radius:6px; border:1px solid #e5e7eb; background:#fff; font-size:11.5px; font-weight:500; color:#00897B; transition:background .1s; }
        .btn-view:hover { background:#E0F2F1; }
        .btn-dl { padding:5px 12px; border-radius:6px; border:none; background:#00897B; font-size:11.5px; font-weight:600; color:#fff; transition:background .1s; }
        .btn-dl:hover { background:#00695C; }
        .btn-proc { padding:5px 12px; border-radius:6px; border:1px solid #e5e7eb; background:#f9fafb; font-size:11.5px; color:#9ca3af; cursor:not-allowed; }
        .empty-state { background:#fff; border:1px solid #e5e7eb; border-radius:10px; padding:48px 24px; text-align:center; }
        .empty-icon { width:48px; height:48px; border-radius:12px; background:#f1f5f9; display:flex; align-items:center; justify-content:center; margin:0 auto 14px; }
        .empty-icon svg { width:24px; height:24px; stroke:#9ca3af; fill:none; stroke-width:1.8; }
        .empty-title { font-size:14px; font-weight:600; color:#374151; margin-bottom:4px; }
        .empty-sub { font-size:12px; color:#9ca3af; }

        @keyframes spin { to { transform:rotate(360deg); } }
        @media (max-width:900px) { .stats { grid-template-columns:repeat(2,1fr); } }
        @media (max-width:600px) { .content { padding:10px; } .stats { grid-template-columns:repeat(2,1fr); } }
      `}</style>

      <div className="app">
        {/* SIDEBAR */}
        <aside className="sb">
          <div className="sb-logo">
            <div className="sb-logo-box">
              <img src="/micronlabs.png" alt="MicronLabs" style={{ width:"18px", height:"18px", objectFit:"contain" }}/>
            </div>
            <div>
              <div className="sb-logo-name">MicronLabs</div>
              <div className="sb-logo-sub">Laboratory Information System</div>
            </div>
          </div>
          <nav className="sb-nav">
            <div className="sb-grp">Main</div>
            {[
              { id:"dashboard", label:"Dashboard", icon:<><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></> },
              { id:"requisitions", label:"E-Requisitions", icon:<><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><path d="M14 14h7v7"/></> },
              { id:"results", label:"Lab Results", icon:<><path d="M9 3h6M9 3v8l-4 9h14l-4-9V3"/></> },
              { id:"prescriptions", label:"Prescriptions", icon:<><path d="M10.5 20H4a2 2 0 01-2-2v-3.5a2 2 0 012-2h6.5"/><path d="M13.5 4H20a2 2 0 012 2v3.5a2 2 0 01-2 2h-6.5"/><path d="M10.5 20l9-16"/></> },
              { id:"records", label:"Health Records", icon:<><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><path d="M14 2v6h6M16 13H8M16 17H8"/></> },
            ].map(({ id, label, icon }) => (
              <button key={id} className={`nb ${id==="results"?"on":""}`} onClick={() => navigate(`/${id}`)}>
                <span className="nav-ic"><svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">{icon}</svg></span>
                <span className="nav-lbl">{label}</span>
              </button>
            ))}
            <div className="sb-grp" style={{marginTop:8}}>Account</div>
            {[
              { id:"messages", label:"Messages", icon:<><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></> },
              { id:"billing", label:"Billing", icon:<><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></> },
              { id:"profile", label:"My Profile", icon:<><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></> },
            ].map(({ id, label, icon }) => (
              <button key={id} className="nb" onClick={() => navigate(`/${id}`)}>
                <span className="nav-ic"><svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">{icon}</svg></span>
                <span className="nav-lbl">{label}</span>
              </button>
            ))}
          </nav>
          <div className="sb-foot">
            <div className="sb-user">
              <div className="sb-av">U</div>
              <div className="sb-uinfo">
                <div className="sb-uname">My Account</div>
                <div className="sb-urole">Patient</div>
              </div>
            </div>
            <button className="sb-out" onClick={handleLogout}>
              <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/></svg>
              <span className="sb-out-lbl">Sign out</span>
            </button>
          </div>
        </aside>

        {/* MAIN */}
        <div className="main">
          <header className="topbar">
            <div className="tb-l">
              <button className="tb-toggle" onClick={() => setSideOpen(o => !o)}>
                <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M4 6h16M4 12h16M4 18h16"/></svg>
              </button>
              <div>
                <div className="tb-title">Lab Results</div>
                <div className="tb-sub">{new Date().toLocaleDateString("en-US", { weekday:"long", month:"long", day:"numeric" })}</div>
              </div>
            </div>
            <div className="tb-r">
              <div className="tb-badge">
                <svg width="11" height="11" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5z"/></svg>
                HIPAA secured
              </div>
              <div className="tb-av">U</div>
            </div>
          </header>

          <div className="content">
            <div className="page-head">
              <div className="page-title">Lab results and reports</div>
              <div className="page-sub">View, download and share your diagnostic results and PDF reports</div>
            </div>

            <div className="stats">
              <div className="stat"><div className="stat-lbl">Total results</div><div className="stat-n">{results.length}</div></div>
              <div className="stat"><div className="stat-lbl">Completed</div><div className="stat-n" style={{color:"#16a34a"}}>{completed}</div></div>
              <div className="stat"><div className="stat-lbl">Pending</div><div className="stat-n" style={{color:"#ca8a04"}}>{pending}</div></div>
              <div className="stat"><div className="stat-lbl">Flagged for review</div><div className="stat-n" style={{color:"#dc2626"}}>{flagged}</div></div>
            </div>

            <div className="filter-row">
              {[
                { key:"all", label:`All results (${results.length})` },
                { key:"completed", label:`Completed (${completed})` },
                { key:"pending", label:`Pending (${pending})` },
                { key:"flagged", label:`Flagged (${flagged})` },
              ].map(({ key, label }) => (
                <button key={key} className={`f-btn ${filter===key?"on":""}`} onClick={() => setFilter(key)}>{label}</button>
              ))}
            </div>

            <div className="results-list">
              {(filter === "flagged" ? results.filter(r => r.flagged) : filtered).length === 0 ? (
                <div className="empty-state">
                  <div className="empty-icon"><svg viewBox="0 0 24 24"><path d="M9 3h6M9 3v8l-4 9h14l-4-9V3"/></svg></div>
                  <div className="empty-title">No results found</div>
                  <div className="empty-sub">Your lab results will appear here once available</div>
                </div>
              ) : (
                (filter === "flagged" ? results.filter(r => r.flagged) : filtered).map(r => (
                  <div key={r.id} className={`res-card ${r.flagged ? "flagged" : ""}`}>
                    <div className="res-icon">
                      <svg viewBox="0 0 24 24"><path d="M9 3h6M9 3v8l-4 9h14l-4-9V3"/></svg>
                    </div>
                    <div style={{flex:1, minWidth:0}}>
                      <div style={{display:"flex", alignItems:"center", flexWrap:"wrap", gap:4, marginBottom:3}}>
                        <span className="res-name">{r.name}</span>
                        <span className="res-cat">{r.category}</span>
                        {r.flagged && <span className="flag-tag">Review needed</span>}
                      </div>
                      <div className="res-meta">{r.doctor} &nbsp;·&nbsp; {fmtDate(r.date)}</div>
                    </div>
                    <div style={{display:"flex", alignItems:"center", gap:8, flexShrink:0}}>
                      <span className={`status-pill ${r.status==="completed" ? "pill-green" : "pill-yellow"}`}>
                        {r.status === "completed" ? "Completed" : "Processing"}
                      </span>
                      {r.status === "completed" ? (
                        <><button className="btn-view">View</button><button className="btn-dl">Download PDF</button></>
                      ) : (
                        <button className="btn-proc" disabled>Processing…</button>
                      )}
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ResultsPage;